// extracted by mini-css-extract-plugin
export default {"overrideWidth":"UserPerformance_overrideWidth__uxvI-"};